import { render, staticRenderFns } from "./EditCrashVersionModal.vue?vue&type=template&id=c8a784ee&"
import script from "./EditCrashVersionModal.vue?vue&type=script&lang=js&"
export * from "./EditCrashVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCrashVersionModal.vue?vue&type=style&index=0&id=c8a784ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports